import Header from "@commons/header";
import Column from "@components/column";
import Tab from "@components/tabs";
import React from "react";
import Category from "./category";
import SubCategory from "./sub-category";
import ManageSectionTitle from "./manage-section-title";

const CategorySetup = () => {
  const items: any = [
    { label: "Category", component: Category },
    { label: "Sub-Category", component: SubCategory },
    { label: "Manage Section Title", component: ManageSectionTitle },
  ];
  return (
    <Column>
      <Header title="Category Setup" />
      <Tab items={items} fitContent={true} />
    </Column>
  );
};

export default CategorySetup;
